import { Box, Typography } from '@mui/material';
import { tokens } from '../theme';

export default function BusinessUnitChip({ unit }: { unit?: string | null }) {
  if (!unit) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }
  const isRuby = unit === 'RUBY';
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        border: `1px solid ${tokens.border}`,
        bgcolor: tokens.soft,
        borderRadius: 999,
        px: 1,
        py: 0.15,
      }}
    >
      <Box
        sx={{
          width: 7,
          height: 7,
          borderRadius: '50%',
          bgcolor: isRuby ? tokens.ruby : tokens.fg,
        }}
      />
      <Typography variant="caption" fontWeight={500}>
        {isRuby ? 'Ruby' : 'Kalotte'}
      </Typography>
    </Box>
  );
}
